import styled, { css } from 'styled-components';
import { getWidth } from '@components/styles';

export interface FormContainerProps {
  hasSidebar?: boolean;
  wider?: boolean;
  customWidth?: number;
  collapseOnMobile?: boolean;
  veryWider?: boolean;
  noMinHeight?: boolean;
}

export const FormContainer = styled.div<FormContainerProps>`
  max-width: none;
  padding: 0 24px 24px;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  min-height: calc(100vh - ${({ theme }) => theme.sizes.navbarMobile});

  ${({ theme }) => `@media screen and ${theme.device.mobileS}`} {
    max-width: ${getWidth(8)};
    padding: 0 24px 32px;
    margin: 0 auto;
  }

  ${({ theme }) => `@media screen and ${theme.device.tablet}`} {
    min-height: calc(100vh - ${({ theme }) => theme.sizes.navbar});
    padding-bottom: 60px;
    ${(props) =>
      props.noMinHeight
        ? css`
            min-height: auto;
          `
        : null}
  }

  ${(props) =>
    props.hasSidebar
      ? css`
          ${({ theme }) => `@media screen and ${theme.device.tablet}`} {
            margin-left: calc(64px + ${getWidth(5)});
            max-width: ${getWidth(8)};
            margin-right: auto;
          }
        `
      : null}

  ${({ theme }) => `@media screen and ${theme.device.laptopL}`} {
    max-width: ${getWidth(10)};
    padding: 0 0 80px;
    margin-left: auto;
  }

  ${({ theme }) => `@media screen and ${theme.device.laptopXL}`} {
    max-width: ${getWidth(10)};
  }

  ${({ theme }) => `@media screen and ${theme.device.desktopL}`} {
    max-width: ${getWidth(11)};
  }

  ${(props) =>
    props.wider
      ? css`
          ${({ theme }) => `@media screen and ${theme.device.mobileS}`} {
            max-width: none;
            padding: 0 20px;
            min-height: auto;
          }

          ${({ theme }) => `@media screen and ${theme.device.tablet}`} {
            max-width: ${getWidth(16)};
            margin: auto;
          }

          ${({ theme }) => `@media screen and ${theme.device.laptop}`} {
            max-width: ${getWidth(16)};
            margin: auto;
          }

          ${({ theme }) => `@media screen and ${theme.device.laptopL}`} {
            max-width: ${getWidth(16)};
            margin: auto;
          }

          ${({ theme }) => `@media screen and ${theme.device.laptopXL}`} {
            max-width: ${getWidth(16)};
            margin: auto;
          }

          ${({ theme }) => `@media screen and ${theme.device.desktopL}`} {
            max-width: ${getWidth(16)};
            margin: auto;
          }
        `
      : null}
  ${(props) =>
    props.veryWider
      ? css`
          ${({ theme }) => `@media screen and ${theme.device.mobileS}`} {
            max-width: none;
            padding: 0 20px;
            min-height: auto;
          }

          ${({ theme }) => `@media screen and ${theme.device.tablet}`} {
            max-width: ${getWidth(20)};
            margin: auto;
          }

          ${({ theme }) => `@media screen and ${theme.device.laptop}`} {
            max-width: ${getWidth(20)};
            margin: auto;
          }

          ${({ theme }) => `@media screen and ${theme.device.laptopL}`} {
            max-width: ${getWidth(20)};
            margin: auto;
          }

          ${({ theme }) => `@media screen and ${theme.device.laptopXL}`} {
            max-width: ${getWidth(20)};
            margin: auto;
          }

          ${({ theme }) => `@media screen and ${theme.device.desktopL}`} {
            max-width: ${getWidth(20)};
            margin: auto;
          }
        `
      : null}

  ${(props) =>
    props.customWidth
      ? css`
          ${({ theme }) => `@media screen and ${theme.device.mobileS}`} {
            max-width: none;
            padding: 0 20px;
            min-height: auto;
          }

          ${({ theme }) => `@media screen and ${theme.device.tablet}`} {
            max-width: ${getWidth(props.customWidth)};
            margin: auto;
          }

          ${({ theme }) => `@media screen and ${theme.device.laptop}`} {
            max-width: ${getWidth(props.customWidth)};
            margin: auto;
          }

          ${({ theme }) => `@media screen and ${theme.device.laptopL}`} {
            max-width: ${getWidth(props.customWidth)};
            margin: auto;
          }

          ${({ theme }) => `@media screen and ${theme.device.laptopXL}`} {
            max-width: ${getWidth(props.customWidth)};
            margin: auto;
          }

          ${({ theme }) => `@media screen and ${theme.device.desktopL}`} {
            max-width: ${getWidth(props.customWidth)};
            margin: auto;
          }
        `
      : null}

  ${(props) =>
    props.collapseOnMobile
      ? css`
          padding: 0 !important;

          ${({ theme }) => `@media screen and ${theme.device.laptopS}`} {
            padding: 0 20px !important;
          }
        `
      : null}
`;

export default FormContainer;
